import React from 'react';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Heading } from '@abyss/web/ui/Heading';
import { V2Button } from '@abyss/web/ui/Button';

import classNames from 'classnames';

import styles from './greycta.module.css';

export const GreyCta = () => {
  return (
    <div className={styles.ctaContainer}>
      <div className={styles.cta}>
        <div className={styles.ctaWrap}>
          <div className={styles.ctaContent}>
            <div className={styles.ctaContentIcon}>
              <IconSymbol
                className={styles.symbol}
                icon="favorite"
                color="#002677"
                variant="outlined"
                size="40px"
              />
            </div>
            <div>
              <div>
                <Heading.Level>
                  <Heading className={styles.title}>
                    Want to save this plan?
                  </Heading>
                </Heading.Level>
              </div>
              <div className={styles.ctaContentCopy}>
                Easily create a guest account to keep track of your drugs,
                doctors and saved plans as you shop.{' '}
              </div>
            </div>
          </div>
          <div className={styles.ctaButton}>
            <V2Button variant="outline">Get started</V2Button>
          </div>
        </div>
      </div>
    </div>
  );
};
